import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  cleanupWebSocket,
  initializeWebSocket,
  setupHeartbeatHandler,
  setupNotificationHandler,
} from 'services/webSocketService';

const WebSocketInitializer = observer(() => {
  const {
    UserStore: { isAuthenticated },
    WebSocketStore,
    NotificationStore,
  } = useStore();

  useEffect(() => {
    // Only connect if user is authenticated
    if (isAuthenticated) {
      // Initialize WebSocket connection
      initializeWebSocket(WebSocketStore);

      // Set up heartbeat handler
      setupHeartbeatHandler(WebSocketStore);

      // Set up notification handler
      setupNotificationHandler(WebSocketStore, notification => {
        // Add notification to store
        NotificationStore.addNotification(notification);

        // Optionally show toast notification
        toast.info(notification.message || notification.title, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });

      // Cleanup on unmount or when authentication changes
      return () => {
        cleanupWebSocket(WebSocketStore);
      };
    } else {
      // Disconnect if user is not authenticated
      cleanupWebSocket(WebSocketStore);
    }
  }, [isAuthenticated, WebSocketStore, NotificationStore]);

  // This component doesn't render anything
  return null;
});

export default WebSocketInitializer;
